var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ "phome", _vm.ended ? 'is-ended' : '', _vm.paused && ! _vm.hasThumbnail ? 'is-paused' : '' ]},[_c('uhv-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }